import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicalCross: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"medical-cross, first-aid, emergency"} maskId="square-filled-radius-0-stroke-1-IconMedicalCross"><path d="M16 8H22V16H16V22H8V16H2V8H8V2H16V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMedicalCross;
